<!-- <div class="row px-3">

    <div class="col-12 col-sm-12 col-md-6" (click)="downloadBollettino()">

        <nb-card>
            <nb-card-body class="card-container-bollettino" style="background-image:url('assets/images/previsioni.png');">

                <div class="card-velo-bollettino"></div>
                <div class="card-content-bollettino">
                    <p>SCARICA ULTIMO BOLLETTINO METEO<br>emesso alle {{dataEmissioneMeteo}}</p>
                </div>

            </nb-card-body>
        </nb-card>

        </div>

        <div class="col-12 col-sm-12 col-md-6" (click)="downloadAvviso()">

        <nb-card>

            

            <nb-card-body class="card-container-bollettino" style="background-image:url('assets/images/scarico_allerta.png');">

                <div class="card-velo-bollettino"></div>
                <div class="card-content-bollettino">
                    <p>SCARICA ULTIMO AVVISO DI ALLERTA<br>emesso il {{dataEmissione}}</p>
                </div>

            </nb-card-body>
        </nb-card>

        </div>

</div> -->
<div class="download-area">
    <div class="d-flex buttonWrapper containerBg1" (click)="downloadBollettino()" >
        <label class="custom-file-upload downloadButton d-flex flex-column">
            <div class="folder animated-folder">
                <div class="front-side">
                    <div class="tip"></div>
                    <div class="cover"></div>
                </div>
                <div class="back-side cover"></div>
            </div>
            <div><span class="titolo-download">SCARICA ULTIMO BOLLETTINO METEO</span></div>
            <div><span class="data-download"><i>emesso il {{dataEmissioneMeteo}}</i></span></div>
        </label>
    </div>
    <div class="d-flex buttonWrapper containerBg1" (click)="downloadAvviso()">
        <label class="custom-file-upload downloadButton d-flex flex-column">
            <div class="folder animated-folder">
                <div class="front-side">
                    <div class="tip"></div>
                    <div class="cover"></div>
                </div>
                <div class="back-side cover"></div>
            </div>
            <div><span class="titolo-download">SCARICA ULTIMO AVVISO ALLERTA</span></div>
            <div><span class="data-download"><i>emesso il {{dataEmissione}}</i></span></div>
        </label>
    </div>
</div>

<!-- <div class="buttonsContainer">
    <div class="p-1 buttonWrapper" style="transform: scale(0.9);">
        <div class="container containerBg1" (click)="downloadBollettino()">
            <div class="folder">
                <div class="front-side">
                    <div class="tip"></div>
                    <div class="cover"></div>
                </div>
                <div class="back-side cover"></div>
            </div>
            <label class="custom-file-upload downloadButton d-flex flex-column" (click)="downloadBollettino()">
                <p>SCARICA ULTIMO BOLLETTINO METEO<br>emesso alle {{dataEmissioneMeteo}}</p>
            </label>
        </div>
    </div>
    <div class="p-1 buttonWrapper" style="transform: scale(0.9);">
        <div class="container containerBg1" >
            <div class="folder">
                <div class="front-side">
                    <div class="tip"></div>
                    <div class="cover"></div>
                </div>
                <div class="back-side cover"></div>
            </div>
            <label class="custom-file-upload d-flex flex-column" (click)="downloadAvviso()">
                <p>SCARICA ULTIMO AVVISO DI ALLERTA<br>emesso il {{dataEmissione}}</p>
            </label>
        </div>
    </div>
</div> -->